'use client';
import React, { useState, useEffect } from 'react';
import AppLogo from '@/components/ui/AppLogo';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const openSMS = () => {
    const message = 'Hi! I would like to book a car detail appointment.';
    const a = document.createElement('a');
    a.href = `sms:16474500681?body=${encodeURIComponent(message)}`;
    document.body?.appendChild(a);
    a?.click();
    document.body?.removeChild(a);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-black/90 backdrop-blur-xl border-b border-blue-500/20 shadow-plum-sm py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between">
        <div className="flex items-center gap-3 cursor-pointer">
          <AppLogo
            src="/assets/images/ChatGPT_Image_Apr_28_2026_01_42_10_PM-1778216489168.png"
            size={64}
            className="cursor-pointer"
          />
          <span className={`font-bold text-base leading-tight transition-colors ${scrolled ? 'text-white' : 'text-white'}`}>
            YYC Shine<br />Auto Detailing
          </span>
        </div>

        <nav className="hidden md:flex items-center gap-8 text-sm font-600 text-white/60">
          <a href="#services" className="hover:text-white transition-colors font-semibold">Services</a>
          <a href="#how-it-works" className="hover:text-white transition-colors font-semibold">How It Works</a>
          <a href="#reviews" className="hover:text-white transition-colors font-semibold">Reviews</a>
        </nav>

        <button onClick={openSMS} className="btn-mint text-sm">
          <span>Book My Appointment</span>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
          </svg>
        </button>
      </div>
    </header>
  );
}